<div class="review-page bg-[#F8FAFC] min-h-screen">

    <!-- Hero Banner -->
    <section
        class="review-hero relative overflow-hidden bg-gradient-to-br from-[#163861] via-[#1E4F87] to-[#163861] text-white pt-24 pb-20 px-4 sm:px-6 lg:px-8">
        <!-- Ambient background glows -->
        <div class="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#35cfa6]/15 blur-3xl pointer-events-none">
        </div>
        <div class="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-[#35cfa6]/10 blur-3xl pointer-events-none">
        </div>

        <div class="max-w-6xl mx-auto text-center relative z-10">
            <!-- Trustpilot Style Rating Pill -->
            <div
                class="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-xs sm:text-sm font-medium text-white mb-6 shadow-inner">
                <span class="font-bold text-white tracking-wide">4.9 / 5</span>
                <div class="flex items-center gap-0.5 text-[#00B67A]">
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                    <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                </div>
                <span class="font-bold tracking-tight text-[#00B67A] flex items-center gap-1">
                </span>
                <span class="text-white/60">|</span>
                <span class="text-white/85">Berdasarkan 1.240+ ulasan</span>
            </div>

            <h1
                class="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-4 font-['Inter',sans-serif]">
                Ulasan & Pengalaman <span class="text-[#35cfa6]">Pelanggan</span>
            </h1>
            <p class="text-base sm:text-lg text-slate-200 max-w-2xl mx-auto mb-8 font-normal leading-relaxed">
                Cerita nyata dari pasangan, event planner, dan mitra yang mempercayakan momen spesial mereka bersama
                Visidea Studio.
            </p>

            <!-- Action Buttons in Hero -->
            <div class="flex flex-wrap items-center justify-center gap-4">
                <button (click)="scrollToGrid()"
                    class="px-6 py-3 rounded-full bg-[#35cfa6] text-[#163861] font-bold hover:bg-[#5fe1bd] transition-all duration-200 shadow-lg shadow-[#35cfa6]/25 flex items-center gap-2">
                    <span>Lihat Semua Review</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Wave Divider -->
        <div class="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none pointer-events-none">
            <svg class="relative block w-full h-8 sm:h-12 text-[#F8FAFC]" viewBox="0 0 1200 120"
                preserveAspectRatio="none">
                <path
                    d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,121.31,200,105,241.6,95.19,282.8,76.53,321.39,56.44Z"
                    fill="currentColor"></path>
            </svg>
        </div>
    </section>

    <!-- Stats Highlight Section -->
    <section class="max-w-6xl mx-auto px-4 sm:px-6 -mt-6 mb-12 sm:mb-16 relative z-20">
        <div
            class="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 bg-white rounded-2xl shadow-xl shadow-slate-200/60 p-6 border border-slate-100">
            <div class="text-center p-3 border-r border-slate-100 last:border-none">
                <div class="text-2xl sm:text-3xl font-extrabold text-[#163861]">4.9<span
                        class="text-[#35cfa6] text-xl">/5.0</span></div>
                <div class="text-xs sm:text-sm text-slate-500 font-medium mt-1">Rating Rata-rata</div>
            </div>
            <div class="text-center p-3 md:border-r border-slate-100">
                <div class="text-2xl sm:text-3xl font-extrabold text-[#163861]">1.200<span
                        class="text-[#35cfa6]">+</span></div>
                <div class="text-xs sm:text-sm text-slate-500 font-medium mt-1">Klien Puas</div>
            </div>
            <div class="text-center p-3 border-r border-slate-100 last:border-none">
                <div class="text-2xl sm:text-3xl font-extrabold text-[#163861]">99.8<span
                        class="text-[#35cfa6]">%</span></div>
                <div class="text-xs sm:text-sm text-slate-500 font-medium mt-1">Kepuasan Layanan</div>
            </div>
            <div class="text-center p-3">
                <div class="text-2xl sm:text-3xl font-extrabold text-[#163861]">100<span class="text-[#35cfa6]">%</span>
                </div>
                <div class="text-xs sm:text-sm text-slate-500 font-medium mt-1">Ulasan Terverifikasi</div>
            </div>
        </div>
    </section>

    <!-- SECTION 2: EXPLORE ALL REVIEWS WITH SEARCH & FILTERS -->
    <section id="all-reviews-grid" class="py-16 bg-white border-t border-slate-200/60 px-4 sm:px-6 lg:px-8">
        <div class="max-w-7xl mx-auto">

            <div class="text-center max-w-2xl mx-auto mb-10">
                <h2 class="text-2xl sm:text-4xl font-extrabold text-[#163861] mt-3">
                    Semua Ulasan Pelanggan Visidea
                </h2>
                <p class="text-slate-600 text-sm sm:text-base mt-2">
                    Filter ulasan berdasarkan jenis layanan dan rating kepuasan yang Anda cari.
                </p>
            </div>

            <!-- Filters and Search Toolbar -->
            <div class="bg-[#F8FAFC] rounded-2xl p-4 sm:p-6 border border-slate-200 mb-10 shadow-sm">
                <div class="flex flex-col md:flex-row items-center justify-between gap-4">

                    <!-- Search Input -->
                    <div class="relative w-full md:w-80">
                        <svg class="w-5 h-5 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                        <input type="text" [(ngModel)]="searchQuery" placeholder="Cari review atau kata kunci..."
                            class="w-full pl-11 pr-4 py-2.5 rounded-xl border border-slate-300 bg-white text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#35cfa6] focus:border-transparent">
                    </div>

                    <!-- Category Chips -->
                    <div class="flex flex-wrap items-center justify-center gap-2 w-full md:w-auto">
                        <button (click)="setCategory('all')" [class.bg-[#163861]]="selectedCategory === 'all'"
                            [class.text-white]="selectedCategory === 'all'"
                            [class.bg-white]="selectedCategory !== 'all'"
                            [class.text-slate-700]="selectedCategory !== 'all'"
                            class="px-3.5 py-1.5 rounded-full text-xs font-semibold border border-slate-200 hover:border-[#163861] transition-all">
                            Semua Layanan
                        </button>
                        <button (click)="setCategory('photobooth')"
                            [class.bg-[#163861]]="selectedCategory === 'photobooth'"
                            [class.text-white]="selectedCategory === 'photobooth'"
                            [class.bg-white]="selectedCategory !== 'photobooth'"
                            [class.text-slate-700]="selectedCategory !== 'photobooth'"
                            class="px-3.5 py-1.5 rounded-full text-xs font-semibold border border-slate-200 hover:border-[#163861] transition-all">
                            Photobooth
                        </button>
                        <button (click)="setCategory('invitation')"
                            [class.bg-[#163861]]="selectedCategory === 'invitation'"
                            [class.text-white]="selectedCategory === 'invitation'"
                            [class.bg-white]="selectedCategory !== 'invitation'"
                            [class.text-slate-700]="selectedCategory !== 'invitation'"
                            class="px-3.5 py-1.5 rounded-full text-xs font-semibold border border-slate-200 hover:border-[#163861] transition-all">
                            Undangan Digital
                        </button>
                        <button (click)="setCategory('videobooth')"
                            [class.bg-[#163861]]="selectedCategory === 'videobooth'"
                            [class.text-white]="selectedCategory === 'videobooth'"
                            [class.bg-white]="selectedCategory !== 'videobooth'"
                            [class.text-slate-700]="selectedCategory !== 'videobooth'"
                            class="px-3.5 py-1.5 rounded-full text-xs font-semibold border border-slate-200 hover:border-[#163861] transition-all">
                            360 Videobooth
                        </button>
                        <button (click)="setCategory('guestbook')"
                            [class.bg-[#163861]]="selectedCategory === 'guestbook'"
                            [class.text-white]="selectedCategory === 'guestbook'"
                            [class.bg-white]="selectedCategory !== 'guestbook'"
                            [class.text-slate-700]="selectedCategory !== 'guestbook'"
                            class="px-3.5 py-1.5 rounded-full text-xs font-semibold border border-slate-200 hover:border-[#163861] transition-all">
                            Guest Book
                        </button>
                    </div>

                    <!-- Rating Filter & Write Review Button -->
                    <div class="flex items-center gap-3 w-full md:w-auto justify-end">
                        <select [(ngModel)]="sortBy"
                            class="px-3 py-2 rounded-xl border border-slate-300 bg-white text-xs font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#35cfa6]">
                            <option value="newest">Terbaru</option>
                            <option value="highest">Rating Tertinggi</option>
                            <option value="likes">Paling Bermanfaat</option>
                        </select>
                    </div>

                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="filteredReviews.length === 0"
                class="text-center py-16 bg-slate-50 rounded-2xl border border-dashed border-slate-300">
                <div
                    class="w-16 h-16 mx-auto mb-4 rounded-full bg-slate-100 flex items-center justify-center text-slate-400">
                    <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                        </path>
                    </svg>
                </div>
                <h3 class="text-lg font-bold text-slate-700">Tidak ada ulasan yang sesuai</h3>
                <p class="text-sm text-slate-500 mt-1">Coba sesuaikan kata kunci pencarian atau filter layanan Anda.</p>
                <button (click)="searchQuery = ''; selectedCategory = 'all'; selectedRating = 'all'"
                    class="mt-4 px-4 py-2 rounded-lg bg-[#163861] text-white text-xs font-semibold">
                    Reset Filter
                </button>
            </div>

            <!-- Reviews Grid -->
            <div *ngIf="filteredReviews.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <div *ngFor="let review of filteredReviews"
                    class="bg-white rounded-2xl p-6 border border-slate-200/90 shadow-sm hover:shadow-md transition-all duration-200 flex flex-col justify-between">

                    <div>
                        <!-- Header: User Avatar & Info -->
                        <div class="flex items-start justify-between gap-3 mb-4">
                            <div class="flex items-center gap-3">
                                <img [src]="review.avatar" [alt]="review.name"
                                    class="w-11 h-11 rounded-full object-cover border border-slate-200">
                                <div>
                                    <h4 class="font-bold text-[#163861] text-sm leading-tight flex items-center gap-1">
                                        {{ review.name }}
                                        <svg *ngIf="review.verified" class="w-3.5 h-3.5 text-[#00B67A] fill-current"
                                            viewBox="0 0 24 24">
                                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                        </svg>
                                    </h4>
                                    <span class="text-xs text-slate-400 font-medium">{{ review.date }}</span>
                                </div>
                            </div>
                            <span class="text-[11px] font-semibold px-2.5 py-1 rounded-md bg-slate-100 text-slate-700">
                                {{ review.service }}
                            </span>
                        </div>

                        <!-- Star Rating -->
                        <div class="flex items-center gap-1 text-[#00B67A] mb-3">
                            <svg *ngFor="let star of [1,2,3,4,5]" class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                                <path
                                    d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                        </div>

                        <!-- Title & Comment -->
                        <h5 *ngIf="review.title" class="font-bold text-[#163861] text-sm mb-1.5">
                            {{ review.title }}
                        </h5>
                        <p class="text-slate-600 text-sm leading-relaxed">
                            {{ review.comment }}
                        </p>
                    </div>

                    <!-- Card Footer: Like & Verified -->
                    <div class="mt-6 pt-4 border-t border-slate-100 flex items-center justify-between">
                        <span class="text-xs text-[#00B67A] font-semibold flex items-center gap-1">
                            <svg class="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
                                <path
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                            </svg>
                            Terverifikasi
                        </span>

                        <button (click)="toggleLike(review)" [class.text-[#163861]]="review.hasLiked"
                            [class.text-slate-400]="!review.hasLiked"
                            class="flex items-center gap-1.5 text-xs font-semibold hover:text-[#163861] transition-colors">
                            <svg class="w-4 h-4" [class.fill-current]="review.hasLiked" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5">
                                </path>
                            </svg>
                            <span>Bermanfaat ({{ review.likes || 0 }})</span>
                        </button>
                    </div>

                </div>

            </div>

        </div>
    </section>


    <!-- MODAL: TULIS REVIEW -->
    <div *ngIf="isWriteReviewModalOpen"
        class="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fadeIn">
        <div class="bg-white rounded-3xl max-w-lg w-full p-6 sm:p-8 shadow-2xl relative border border-slate-100">

            <!-- Close Button -->
            <button (click)="closeWriteReviewModal()"
                class="absolute top-5 right-5 text-slate-400 hover:text-slate-600 p-2 rounded-full hover:bg-slate-100 transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                </svg>
            </button>

            <!-- Success notification -->
            <div *ngIf="submitSuccessMessage"
                class="mb-6 p-4 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm font-medium flex items-center gap-2">
                <svg class="w-5 h-5 text-emerald-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg>
                <span>{{ submitSuccessMessage }}</span>
            </div>

            <div class="text-center mb-6">
                <h3 class="text-xl font-bold text-[#163861]">Tulis Ulasan Anda</h3>
                <p class="text-xs text-slate-500 mt-1">Bagikan pengalaman berharga Anda menggunakan layanan Visidea
                    Studio.</p>
            </div>

            <form (ngSubmit)="submitNewReview()" class="space-y-4">

                <!-- Star Rating Picker -->
                <div class="text-center pb-2">
                    <label class="block text-xs font-semibold text-slate-600 mb-2">Beri Rating</label>
                    <div class="flex items-center justify-center gap-2 text-2xl text-amber-400">
                        <button *ngFor="let s of [1,2,3,4,5]" type="button" (click)="setNewReviewRating(s)"
                            class="focus:outline-none transform hover:scale-125 transition-transform">
                            <span [class.text-[#00B67A]]="s <= newReview.rating"
                                [class.text-slate-300]="s > newReview.rating">★</span>
                        </button>
                    </div>
                </div>

                <!-- Nama Lengkap -->
                <div>
                    <label class="block text-xs font-semibold text-slate-700 mb-1">Nama Lengkap *</label>
                    <input type="text" [(ngModel)]="newReview.name" name="name" required
                        placeholder="Contoh: Ryan & Jessica"
                        class="w-full px-4 py-2.5 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-[#35cfa6]">
                </div>

                <!-- Layanan -->
                <div>
                    <label class="block text-xs font-semibold text-slate-700 mb-1">Layanan yang Digunakan *</label>
                    <select [(ngModel)]="newReview.service" name="service"
                        class="w-full px-4 py-2.5 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-[#35cfa6] bg-white">
                        <option value="Photobooth">Photobooth</option>
                        <option value="Digital Invitation">Digital Invitation (Undangan Digital)</option>
                        <option value="360 Videobooth">360 Videobooth</option>
                        <option value="Guest Book">Digital Guest Book</option>
                        <option value="Event Organizer">Event Organizer</option>
                        <option value="Professional Photographer">Professional Photographer</option>
                        <option value="Smart Ticketing">Smart Ticketing</option>
                        <option value="Bundling Package">Bundling Package</option>
                    </select>
                </div>

                <!-- Judul Ulasan -->
                <div>
                    <label class="block text-xs font-semibold text-slate-700 mb-1">Judul Ulasan (Opsional)</label>
                    <input type="text" [(ngModel)]="newReview.title" name="title"
                        placeholder="Contoh: Pelayanan sangat memuaskan dan ramah"
                        class="w-full px-4 py-2.5 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-[#35cfa6]">
                </div>

                <!-- Isi Ulasan -->
                <div>
                    <label class="block text-xs font-semibold text-slate-700 mb-1">Pengalaman / Testimoni Anda *</label>
                    <textarea [(ngModel)]="newReview.comment" name="comment" required rows="4"
                        placeholder="Ceritakan pengalaman Anda bersama tim Visidea Studio..."
                        class="w-full px-4 py-2.5 rounded-xl border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-[#35cfa6]"></textarea>
                </div>

                <div class="pt-2">
                    <button type="submit" [disabled]="isSubmittingReview || !newReview.name || !newReview.comment"
                        class="w-full py-3 rounded-xl bg-[#35cfa6] hover:bg-[#5fe1bd] text-[#163861] font-bold text-sm shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed">
                        <span *ngIf="!isSubmittingReview">Kirim Ulasan</span>
                        <span *ngIf="isSubmittingReview">Mengirim ulasan...</span>
                    </button>
                </div>

            </form>

        </div>
    </div>

</div>